import {useEffect, useState} from "react"
import OrderService from "../../services/order/OrderService"
import {Grid, Typography} from "@mui/material"
import FieldDisplay from "../formatting/FieldDisplay"
import {makeStyles} from "tss-react/mui"

export interface SmsSubscriptionResponse {
	orderNumber: string
	phoneNumber: string
	shopperId: string
	createdDate: string
}

const useStyles = makeStyles()({
	label: {
		fontSize: "12px !important",
	},
})

export function SmsSubscription(props: {orderId: string}) {
	const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined)
	const {classes} = useStyles()
	useEffect(() => {
		const getSmsSubscription = async () => {
			const svc = new OrderService()
			await svc
				.getSmsSubscription(props.orderId)
				.then((result) => {
					if (result) {
						if (result.phoneNumber) {
							setPhoneNumber(result.phoneNumber)
						} else {
							setPhoneNumber("")
						}
					}
				})
				.catch(() => {
					console.log(`error fetching the subscription for the order: ${props.orderId}`)
				})
		}
		getSmsSubscription()
	}, [props.orderId])

	return (
		<div>
			<Grid item style={{paddingTop: "10px"}}>
				<Typography className={classes.label}>SMS Subscription</Typography>
				<Typography color="textPrimary" component="div">
					<div>
						{phoneNumber === undefined ? (
							<Typography>Unable to pull information at this time</Typography>
						) : phoneNumber ? (
							<FieldDisplay label="Phone" data={`+${phoneNumber}`} />
						) : (
							<Typography>No</Typography>
						)}
					</div>
				</Typography>
			</Grid>
		</div>
	)
}
